import BannerBlock from './BannerBlock/BannerBlock'
import LearnMoreBlock from './LearnMoreBlock/LearnMoreBlock'
import AchievementsBlock from './AchievementsBlock/AchievementsBlock'
import TeamBlock from './TeamBlock/TeamBlock'
import SamboProjectBlock from './SamboProjectBlock/SamboProjectBlock'
import NewsBlock from './NewsBlock/NewsBlock'
import FeedbackFormBlock from './FeedbackFormBlock/FeedbackFormBlock'
import ContactsBlock from './ContactsBlock/ContactsBlock'

import style from './indexpage.module.scss'

const IndexPage = () => {
    return (
        <div className={style.indexpage}>
            <BannerBlock />
            <AchievementsBlock />
            <SamboProjectBlock />
            <NewsBlock />
            <FeedbackFormBlock />
            <ContactsBlock />
        </div>
    )
}

export default IndexPage